import {Routes} from '@angular/router';

import {requireEmailVerified} from './guard-helpers';

export const engagementRoutes: Routes = [
        {
                path: 'test',
                canActivate: [requireEmailVerified],
                loadComponent: () => import('../pages/test/test.component').then((c) => c.TestComponent)
        },
        {
                path: 'search',
                canActivate: [requireEmailVerified],
                loadComponent: () => import('../pages/search/search-page.component').then((c) => c.SearchPageComponent)
        },
        {
                path: 'messages',
                canActivate: [requireEmailVerified],
                loadComponent: () => import('../pages/tchat/messages/messages-page.component').then((c) => c.MessagesPageComponent)
        },
        {
                path: 'contacts',
                canActivate: [requireEmailVerified],
                loadComponent: () => import('../pages/contacts/contacts-page.component').then((c) => c.ContactsPageComponent)
        },
        {
                path: 'contact',
                loadComponent: () => import('../pages/contact/contact-page.component').then((c) => c.ContactPageComponent)
        },
        {
                path: 'contactus',
                redirectTo: 'contact',
                pathMatch: 'full'
        }
];
